<script setup lang="ts">
import type {MenuItemInterface} from "~~/server/types/menu";

defineProps<{
    item: MenuItemInterface;
    idx: number;
}>();
</script>

<template>
    <div class="panel panel-full panel--mega_with_content2" :id="`panel-${idx}`" role="menu">
        <div class="panel-header">
            <div class="panel-title">{{ item.name }}</div>
            <NuxtLinkLocale :to="item.url" class="panel-view_all">
              {{$t('view_all')}} <span aria-hidden="true">→</span>
            </NuxtLinkLocale>
        </div>

        <div class="panel-items">
            <div v-for="(col, ck) in item.children" :key="ck" class="item">
                <div class="level_1">
                    <NuxtLinkLocale :to="col.url" class="title">{{ col.name }}</NuxtLinkLocale>
                    <img :src="col.icon" alt="" class="image" loading="lazy" style="object-fit: contain;" />
                </div>

                <div class="products-list">
                    <NuxtLinkLocale
                            v-for="(inner, ik) in (col.children || []).slice(0, 8)"
                            :key="ik"
                            :to="inner.url"
                            class="p-row"
                    >
                        <div class="p-thumb">
                            <img :src="inner.icon" class="p-img" loading="lazy" style="object-fit: contain;" :alt="inner?.name">
                        </div>

                        <div class="p-name">{{ inner.name }}</div>
                    </NuxtLinkLocale>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.panel--mega_with_content2 {
  .panel-items {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;
  }

  .products-list {
    margin-top: 10px;
    display: grid;
    gap: 8px;
  }

  .p-row {
    display: grid;
    grid-template-columns: 56px 1fr;
    gap: 10px;
    align-items: center;
    padding: 10px;
    border-radius: 14px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    background: rgba(255, 255, 255, 0.75);
    text-decoration: none;
    color: inherit;
    transition: transform 0.12s ease, box-shadow 0.12s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.10);
    }
  }

  .p-thumb {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.03);
    display: grid;
    place-items: center;
    overflow: hidden;
  }

  .p-img {
    width: 56px;
    height: 56px;
  }

  .p-img-fallback {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.06);
  }

  .p-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /* optional: ако менюто стане много високо */
  max-height: calc(100vh - 170px);
  overflow: auto;
}
</style>
